import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PetContestDashboard from './pet_contest_dashboard';
import LoginPage from './LoginPage';
import OTPVerificationPage from './OTPVerificationPage';
import { useSeoMetadata } from '../hooks/useSeoMetadata';

const ContestPage: React.FC = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [error, setError] = useState('');

  // Aplicar SEO metadata desde la base de datos (valores globales)
  useSeoMetadata({
    useGlobalSeo: true
  });

  // Restaurar sesión persistente al cargar
  useEffect(() => {
    try {
      const persisted = localStorage.getItem('pc_isLoggedIn');
      const savedEmail = localStorage.getItem('pc_email') || '';
      if (persisted === 'true') {
        setIsLoggedIn(true);
        setUserEmail(savedEmail);
        setShowOTP(false);
      }
    } catch (e) {
      // ignorar errores de storage
    }
  }, []);

  const handleLogin = (email: string) => {
    setUserEmail(email);
    setShowOTP(true);
    setError('');
  };

  const handleError = (errorMessage: string) => {
    setError(errorMessage);
    console.error('Login error:', errorMessage);
  };

  const handleOTPVerify = (otp: string) => {
    console.log('OTP Verified:', otp);
    setIsLoggedIn(true);
    setShowOTP(false);
    try {
      localStorage.setItem('pc_isLoggedIn', 'true');
      if (userEmail) localStorage.setItem('pc_email', userEmail);
    } catch (e) {
      // ignorar errores de storage
    }
  };

  const handleResendOTP = () => {
    console.log('Resending OTP to:', userEmail);
  };

  const handleChangeEmail = () => {
    setShowOTP(false);
    setUserEmail('');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowOTP(false);
    setUserEmail('');
    setError('');
    try {
      localStorage.removeItem('pc_isLoggedIn');
      localStorage.removeItem('pc_email');
    } catch (e) {
      // ignorar errores de storage
    }
    // Opcional: redirigir a login después del logout
    // navigate('/login');
  };

  if (!isLoggedIn && !showOTP) {
    return <LoginPage onLogin={handleLogin} onError={handleError} />;
  }

  if (showOTP) {
    return (
      <OTPVerificationPage
        email={userEmail}
        onVerify={handleOTPVerify}
        onResend={handleResendOTP}
        onChangeEmail={handleChangeEmail}
      />
    );
  }

  return (
    <div className="napc-page min-h-screen text-napc-ink">
      <PetContestDashboard onLogout={handleLogout} />
    </div>
  );
};

export default ContestPage;
